// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"856bf0a6","418":"856bf0a6","651":"856bf0a6","968":"856bf0a6"}[chunkId] + ".chunk.css";
};